import { List } from "@material-ui/core";
import { Grid } from "@material-ui/core";
import React from "react";
import { IndicadorFlat } from "../../../components/Indicador";
import { Venda, VendaMedidas } from "../../../models/venda";
import { ListItemGrupoProduto } from "../../caixa/ListItemGrupoProduto";
import { DashPanel } from "../DashPanel";
import { KPIComparativo } from "../KPIComparativo";

export interface PanelVendaPorGrupoProps {
  vendaPorGrupoProduto: Venda[];
  vendaComparativo?: Venda[];
  totaisProdutos: VendaMedidas;
  totaisComparativo: VendaMedidas;
}

export const PanelVendaPorGrupo = (props: PanelVendaPorGrupoProps) => {
  return (
    <DashPanel title="Venda por Grupo">
      <Grid
        container
        justifyContent="space-between"
        style={{
          paddingLeft: "8px",
          paddingRight: "8px",
          paddingBottom: "8px",
        }}
      >
        <Grid item>
          <IndicadorFlat
            titulo="# Vendas"
            valor={props.totaisProdutos.contagem}
          />
          <KPIComparativo
            valorBase={props.totaisProdutos.contagem}
            valor={props.totaisComparativo.contagem}
            format="0"
          />
        </Grid>
        <Grid item style={{ textAlign: "right" }}>
          <IndicadorFlat
            titulo="Quantidade"
            valor={props.totaisProdutos.quantidade}
            showDecimals={false}
          />
          <KPIComparativo
            valorBase={props.totaisProdutos.quantidade}
            valor={props.totaisComparativo.quantidade}
            format=",0"
          />
        </Grid>
        <Grid item style={{ textAlign: "right" }}>
          <IndicadorFlat
            titulo="Faturamento"
            r$
            valor={props.totaisProdutos.totalLiquido}
            showDecimals={false}
          >
            <KPIComparativo
              valorBase={props.totaisProdutos.totalLiquido}
              valor={props.totaisComparativo.totalLiquido}
              format=",0"
            />
          </IndicadorFlat>
        </Grid>
      </Grid>

      <List>
        {props.vendaPorGrupoProduto?.map((x) => (
          <ListItemGrupoProduto key={x.codigo} {...x} />
        ))}
      </List>
    </DashPanel>
  );
};
